// extracted by mini-css-extract-plugin
module.exports = {"overrideDimmer":"src-components-BudgetBuilder-Versions-SaveNewVerisonModal-styles___overrideDimmer"};